import { Session } from "../types";
import MaterialIcon from "./MaterialIcon";

interface HeaderProps {
  session: Session | null;
  handleLogout: () => void;
  handleMenuClick?: () => void;
}

function Header({ session, handleLogout, handleMenuClick }: HeaderProps) {
  return (
    <header className="bg-grayscale-800 shadow-grayscale-900 flex h-[3.75rem] items-center justify-between p-3 shadow">
      <div className="flex items-center gap-2 text-white">
        {handleMenuClick ? (
          <button onClick={handleMenuClick} className="lg:hidden">
            <MaterialIcon icon="menu" className="text-3xl" />
          </button>
        ) : (
          <></>
        )}
        <h1 className="text-lg font-bold text-white">CAP Timesheet</h1>
      </div>
      <div className="flex gap-2">
        {/* <button className="header-button">Settings</button> */}
        {session !== null ? (
          <button
            onClick={handleLogout}
            className="from-blu-200 to-blu-600 rounded-lg bg-gradient-to-tr p-2 text-sm font-semibold text-black"
          >
            Log Out
          </button>
        ) : (
          <></>
        )}
      </div>
    </header>
  );
}

export default Header;
